import { IconFilterList } from "@/assets/icons";
import { IconSort } from "@/assets/icons/IconSort";
import { SORTING } from "@/constants/sorting";
import { useRsoFilterCache } from "@/features/rso/provider/RsoListFilterCacheProvider";
import { TApiSortsReq } from "@/types/api";
import { FCC } from "@/types/common";
import { Stack } from "@mui/material";
import { Key, useMemo } from "react";

type TTableSortingProps = {
  name: string;
};

export const RsoTableSorting: FCC<TTableSortingProps> = ({ name, children }) => {
  const { rsoFilterCache, setRsoFilterCache } = useRsoFilterCache();

  const onChange = (v: Key) => {
    const newSort = v.toString() as TApiSortsReq;
    setRsoFilterCache({ ...rsoFilterCache, sorts: newSort ? [newSort] : [] });
  };

  const currentSelected = useMemo(() => {
    const found = rsoFilterCache?.sorts?.find((sort) => sort.startsWith(name));
    if (!found) return undefined;
    return [found];
  }, [rsoFilterCache]);

  // Rotate icon
  const shouldRotateIcon = rsoFilterCache?.sorts?.some((item) => typeof item === "string" && item.includes(SORTING.ASC));

  const handleSort = () => {
    let value = "";

    const hasAsc = currentSelected?.some((item) => typeof item === "string" && item.includes(SORTING.ASC));
    const hasDesc = currentSelected?.some((item) => typeof item === "string" && item.includes(SORTING.DESC));

    if (hasAsc) {
      value = `${name}|${SORTING.DESC}`;
    } else if (hasDesc) {
      value = "";
    } else {
      value = `${name}|${SORTING.ASC}`;
    }
    onChange?.(value);
  };

  return (
    <Stack
      direction="row"
      gap={1.25}
      onClick={handleSort}
      sx={{
        cursor: "pointer",
      }}
    >
      {children}
      {currentSelected && currentSelected?.length > 0 ? (
        <IconSort style={shouldRotateIcon ? { transform: "rotate(180deg)" } : undefined} fontSize={24} />
      ) : (
        <IconFilterList fontSize={24} />
      )}
    </Stack>
  );
};
